module.exports = __webpack_public_path__ + "img/informe_detallado.f958301f.svg";